<template>
  <div class="leDelit">
        <div class="Comics container-fluid">

          <div class="row leDelit" >
            <div class="col-12">
                <div class="introDelit">
                    <strong>Weekly Comics for French Journal LeDelit</strong><br> 
A series of comic pages created for the french newspaper Le Delit, McGill University

                </div>
              <img id="comicHere" :src="comics[0].picture">
              <img id="comicHere" :src="comics[1].picture">
              <img id="comicHere" :src="comics[2].picture">
              <img id="comicHere" :src="comics[3].picture">
              <img id="comicHere" :src="comics[4].picture">
              <img id="comicHere" :src="comics[5].picture">
              <img id="comicHere" :src="comics[6].picture">
              <img id="comicHere" :src="comics[7].picture">
              <img id="comicHere" :src="comics[8].picture">
              <img id="comicHere" :src="comics[9].picture">
              <img id="comicHere" :src="comics[10].picture">
              <img id="comicHere" :src="comics[11].picture">
              <img id="comicHere" :src="comics[12].picture">
              
            </div>
            
          </div>
          <div class="row">
              <div class="col-12 leDelit_bottomBtn">
                  <button class="btn_leDelit" v-on:click="scrollTop">Back to the top</button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'leDelit',
  data: () =>({
      comics: [
            {"picture" : require("@/assets/visual/leDelit/img2.png") , "title" : "two"},
            {"picture" : require("@/assets/visual/leDelit/img1.png") , "title" : "one"},
            {"picture" : require("@/assets/visual/leDelit/img3.jpg") , "title" : "three"},
            {"picture" : require("@/assets/visual/leDelit/img4.jpg") , "title" : "four"},
            {"picture" : require("@/assets/visual/leDelit/img5.png") , "title" : "five"},
            {"picture" : require("@/assets/visual/leDelit/img6.jpg") , "title" : "six"},
            {"picture" : require("@/assets/visual/leDelit/img7.png") , "title" : "sept"},
            {"picture" : require("@/assets/visual/leDelit/img8.jpg") , "title" : "eight"},
            {"picture" : require("@/assets/visual/leDelit/img9.png") , "title" : "nine"},
            {"picture" : require("@/assets/visual/leDelit/img10.png") , "title" : "ten"},
            {"picture" : require("@/assets/visual/leDelit/img11.jpg") , "title" : "eleven"},
            {"picture" : require("@/assets/visual/leDelit/img12.jpg") , "title" : "twelve"},
            {"picture" : require("@/assets/visual/leDelit/img13.png") , "title" : "thirteen"},
      ],
      myIndex : 0,
      mainImage: '',
  }),
  mounted: function(){

    this.mainImage = this.comics[this.myIndex].picture

  },
  methods: {
    firstOrLast: function(number){
       // set the images as first or last comic

      this.mainImage = this.comics[number].picture
      this.myIndex = number
    },
    changeImg: function(number){
      if(this.myIndex == 0 && number < 0){
        // don't go back. Stay at 0
        return
      }else if(this.myIndex > this.comics.length -1) {
        this.myIndex = this.comics.length - 1
      }else{
        console.log(this.myIndex)
        this.myIndex += number
        this.mainImage = this.comics[this.myIndex].picture
      }
    },
    scrollTop: function(){
        window.scrollTo(0,0);
    }
  },
computed:{
    getTitle: function(){
        return this.titleImage
    },
    getMainImage: function(){
        return this.mainImage
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Leckerli+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@500&display=swap');
#comicHere{
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.introDelit{
    text-align: justify;
    padding:5% 20% 5% 20%;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.8em;
}

.btn_leDelit{
  font-family: 'Leckerli One', cursive;
  margin:20px;
  border: none;
  color: rgb(255, 255, 255);
  background-color: black;
  padding: 5px 10px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgb(214, 213, 213);
}
.btn_leDelit:hover {
  background-color: rgb(83, 83, 83);
}

div#numberhere{
   margin-left:auto;
   margin-right:auto;
   margin-top:2%;
   margin-bottom:2%;
   display:block;
   text-align:center;
}

#comicHere{
  margin-left:auto;
   margin-right:auto;
   display:block;
   text-align:center;
}
.leDelit_bottomBtn{
  text-align: center;
  margin-bottom: 100px;
}


</style>
